import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import { RoundPipeModule } from '../roundPipe/round.pipe.module';
import { AddFileToDownloadComponent } from './add-file-to-download.component';
import {TranslatePipeModule} from '../translate/translate.pipe.module';
import {FileUploadModule} from 'ng2-file-upload';
import {GenericModalModule} from '../modal/generic-modal.module';
@NgModule({
    imports: [CommonModule,
        RouterModule, RoundPipeModule, FileUploadModule, TranslatePipeModule, GenericModalModule],

  declarations: [ AddFileToDownloadComponent],
  providers: [],
  exports:[ AddFileToDownloadComponent ]
})
export class AddFileToDownloadModule {

}
